(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gut-benefits"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {

    gsap.registerPlugin(ScrollTrigger, SplitText);

    document.querySelectorAll(".gut-benefits").forEach(section => {

        const heading = section.querySelector(".gb-heading");
        const description = section.querySelector(".gb-description");

        if (!heading || !description) return;

        // Split text
        const headingSplit = new SplitText(heading, {
            type: "lines",
            linesClass: "gb-line"
        });

        const descriptionSplit = new SplitText(description, {
            type: "lines",
            mask:"lines",
            linesClass: "gb-line"
        });

        const image = section.querySelector(".gb-image");
        const imageWrap = section.querySelector(".gut-benefits__image");

        const left1 = section.querySelector(".gut-benefits__column--left .gb-feature:nth-child(1)");
        const right1 = section.querySelector(".gut-benefits__column--right .gb-feature:nth-child(1)");
        const left2 = section.querySelector(".gut-benefits__column--left .gb-feature:nth-child(2)");
        const right2 = section.querySelector(".gut-benefits__column--right .gb-feature:nth-child(2)");
        const left3 = section.querySelector(".gut-benefits__column--left .gb-feature:nth-child(3)");
        const right3 = section.querySelector(".gut-benefits__column--right .gb-feature:nth-child(3)");
        const icons = [
            left1?.querySelector(".gb-icon"),
            right1?.querySelector(".gb-icon")
        ].filter(Boolean);

        const icons2 = [
            left2?.querySelector(".gb-icon"),
            right2?.querySelector(".gb-icon")
        ].filter(Boolean);

        const icons3 = [
            left3?.querySelector(".gb-icon"),
            right3?.querySelector(".gb-icon")
        ].filter(Boolean);

        ScrollTrigger.matchMedia({

            // Desktop view (Pehle jaisa tha, bilkul waisa hi)
            "(min-width: 991px)": function() {

                gsap.set(headingSplit.lines, {
                    yPercent: 110
                });

                gsap.set(descriptionSplit.lines, {
                    yPercent: 110
                });

                gsap.set(image, {
                    opacity: 0,
                    y: 80,
                    scale: 0.92,
                    transformOrigin: "50% 50%"
                });

                gsap.set([left1, right1], {
                    opacity: 0,
                    y: 60
                });

                gsap.set([left2, right2], {
                    opacity: 0,
                    y: 60
                });

                gsap.set([left3, right3], {
                    opacity: 0,
                    y: 60
                });

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top top",
                        end: "+=120%",
                        pin: true,
                        scrub: 0.2,
                        anticipatePin: 1,
                        invalidateOnRefresh: true
                    }
                });

                // Heading
                tl.to(headingSplit.lines, {
                    yPercent: 0,
                    duration: 0.08,
                    ease: "none"
                });

                // Description
                tl.to(descriptionSplit.lines, {
                    yPercent: 0,
                    duration: 0.08,
                    ease: "none"
                });

                tl.to(image, {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.12,
                    ease: "none"
                });

                tl.to(section.querySelector(".gut-benefits__grid"), {
                    "--line-scale": 1,
                    duration: 0.10,
                    ease: "none"
                }, "<");

                tl.to([left1, right1], {
                    opacity: 1,
                    y: 0,
                    duration: 0.15,
                    ease: "none"
                });

                tl.to([left2, right2], {
                    opacity: 1,
                    y: 0,
                    duration: 0.15,
                    ease: "none"
                });

                tl.to([left3, right3], {
                    opacity: 1,
                    y: 0,
                    duration: 0.15,
                    ease: "none"
                });

            },

            // Mobile view: Heading, description, icons and image all static, always visible without clipping
            "(max-width: 990px)": function() {

                gsap.set([headingSplit.lines, descriptionSplit.lines], {
                    clearProps: "all",
                    yPercent: 0,
                    opacity: 1
                });

                if (imageWrap) imageWrap.classList.remove("gb-image--hidden");
                gsap.set(image, {
                    clearProps: "all"
                });

                gsap.set([left1, right1, left2, right2, left3, right3], {
                    clearProps: "all"
                });

            }

        });

    });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-isochia-work"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll(".how-it-works").forEach((section) => {
    // On mobile ingredients slider, keep cards fully visible and avoid vertical GSAP displacement
    if (section.classList.contains("how-it-works--ingredients") && window.innerWidth <= 768) {
        const items = section.querySelectorAll(".how-it-works__item");
        items.forEach((item) => {
            item.style.opacity = "1";
            item.style.transform = "none";
        });
        return;
    }

    // On mobile timeline view, keep cards fully visible and let timeline controller handle scroll states
    if (section.classList.contains("how-it-works--timeline") && window.innerWidth <= 768) {
        const items = section.querySelectorAll(".how-it-works__item");
        items.forEach((item) => {
            item.style.opacity = "1";
            item.style.transform = "none";
        });
        return;
    }

    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
        gsap.registerPlugin(ScrollTrigger);

        const items = section.querySelectorAll(".how-it-works__item");

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 75%",
                toggleActions: "play none none reverse"
            }
        });

        items.forEach((item) => {
            // Pop up the step
            tl.to(item, {
                opacity: 1,
                y: 0,
                duration: 0.2,
                ease: "power4.out"
            });

            // Animate arrow
            const arrow = item.querySelector(".how-it-works__arrow");
            if (arrow) {
                tl.to(arrow, {
                    opacity: 1,
                    scaleX: 1,
                    duration: 0.2,
                    ease: "power2.out"
                });
            }
        });
    }
});

// Auto-slide and touch slider controller for mobile ingredients view
function initIngredientsMobileSliders() {
    document.querySelectorAll(".how-it-works--ingredients").forEach((section) => {
        if (section.dataset.sliderInitialized === "true") return;
        section.dataset.sliderInitialized = "true";

        const grid = section.querySelector(".how-it-works__grid.ingredients");
        const dotsContainer = section.querySelector(".how-it-works__dots");
        if (!grid) return;

        const items = Array.from(grid.querySelectorAll(".how-it-works__item"));
        if (items.length <= 1) return;

        const dots = dotsContainer ? Array.from(dotsContainer.querySelectorAll(".how-it-works__dot")) : [];

        let currentIndex = 0;
        let autoSlideTimer = null;
        let isUserInteracting = false;
        let resumeTimeout = null;
        let isVisible = false;

        function setActiveDot(index) {
            currentIndex = index;
            dots.forEach((dot, i) => {
                dot.classList.toggle("is-active", i === index);
            });
        }

        function scrollToSlide(index) {
            if (index < 0) index = 0;
            if (index >= items.length) index = 0;

            const targetItem = items[index];
            if (!targetItem) return;

            const gridRect = grid.getBoundingClientRect();
            const itemRect = targetItem.getBoundingClientRect();
            const targetScrollLeft = grid.scrollLeft + (itemRect.left - gridRect.left) - (grid.clientWidth - targetItem.offsetWidth) / 2;

            grid.scrollTo({
                left: Math.max(0, targetScrollLeft),
                behavior: "smooth"
            });
            setActiveDot(index);
        }

        function nextSlide() {
            if (isUserInteracting || !isVisible || window.innerWidth > 768) return;
            const nextIdx = (currentIndex + 1) % items.length;
            scrollToSlide(nextIdx);
        }

        function startAutoSlide() {
            stopAutoSlide();
            if (window.innerWidth <= 768 && isVisible && !isUserInteracting) {
                autoSlideTimer = setInterval(nextSlide, 3200);
            }
        }

        function stopAutoSlide() {
            if (autoSlideTimer) {
                clearInterval(autoSlideTimer);
                autoSlideTimer = null;
            }
        }

        function handleInteractionStart() {
            isUserInteracting = true;
            stopAutoSlide();
            if (resumeTimeout) clearTimeout(resumeTimeout);
        }

        function handleInteractionEnd() {
            if (resumeTimeout) clearTimeout(resumeTimeout);
            resumeTimeout = setTimeout(() => {
                isUserInteracting = false;
                if (isVisible && window.innerWidth <= 768) {
                    startAutoSlide();
                }
            }, 3500);
        }

        // Active dot update on scroll
        let ticking = false;
        grid.addEventListener("scroll", () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const gridCenter = grid.getBoundingClientRect().left + grid.clientWidth / 2;
                    let closestIdx = 0;
                    let minDiff = Infinity;

                    items.forEach((item, idx) => {
                        const itemCenter = item.getBoundingClientRect().left + item.clientWidth / 2;
                        const diff = Math.abs(gridCenter - itemCenter);
                        if (diff < minDiff) {
                            minDiff = diff;
                            closestIdx = idx;
                        }
                    });

                    setActiveDot(closestIdx);
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });

        // Touch & mouse event listeners
        grid.addEventListener("touchstart", handleInteractionStart, { passive: true });
        grid.addEventListener("touchend", handleInteractionEnd, { passive: true });
        grid.addEventListener("touchcancel", handleInteractionEnd, { passive: true });
        grid.addEventListener("mousedown", handleInteractionStart, { passive: true });
        grid.addEventListener("mouseup", handleInteractionEnd, { passive: true });

        // Dot click navigation
        dots.forEach((dot) => {
            dot.addEventListener("click", () => {
                handleInteractionStart();
                const idx = parseInt(dot.getAttribute("data-index"), 10);
                scrollToSlide(idx);
                handleInteractionEnd();
            });
        });

        // IntersectionObserver for viewport visibility
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    isVisible = entry.isIntersecting;
                    if (isVisible && window.innerWidth <= 768) {
                        startAutoSlide();
                    } else {
                        stopAutoSlide();
                    }
                });
            }, { threshold: 0.15 });
            observer.observe(section);
        } else {
            isVisible = true;
            if (window.innerWidth <= 768) startAutoSlide();
        }

        // Handle resize
        window.addEventListener("resize", () => {
            if (window.innerWidth <= 768) {
                if (!autoSlideTimer && isVisible && !isUserInteracting) {
                    startAutoSlide();
                }
            } else {
                stopAutoSlide();
            }
        }, { passive: true });
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initIngredientsMobileSliders);
} else {
    initIngredientsMobileSliders();
}
setTimeout(initIngredientsMobileSliders, 200);

document.addEventListener("shopify:section:load", (event) => {
    if (event.target && event.target.querySelector(".how-it-works--ingredients")) {
        initIngredientsMobileSliders();
    }
});

// Dynamic timeline track & scroll progress controller for mobile "How Isochia Works"
function initStepsMobileTimeline() {
    const sections = document.querySelectorAll(".how-it-works--timeline");
    if (!sections.length) return;

    sections.forEach((section) => {
        if (section.dataset.timelineInitialized === "true") {
            if (typeof section._updateTimeline === "function") {
                section._updateTimeline();
            }
            return;
        }
        section.dataset.timelineInitialized = "true";

        const grid = section.querySelector(".how-it-works__grid");
        const track = section.querySelector(".how-it-works__timeline-track");
        const bar = section.querySelector(".how-it-works__timeline-bar");
        if (!grid || !track || !bar) return;

        const items = Array.from(section.querySelectorAll(".how-it-works__item"));
        if (items.length < 2) return;

        const circles = items.map((item) => item.querySelector(".how-it-works__title")).filter(Boolean);
        if (circles.length < 2) return;

        function updateTimeline() {
            if (window.innerWidth > 768) {
                track.style.display = "none";
                items.forEach((item) => item.classList.remove("is-active"));
                circles.forEach((c) => c.classList.remove("is-active"));
                return;
            }

            track.style.display = "block";

            const firstCircle = circles[0];
            const lastCircle = circles[circles.length - 1];

            const gridRect = grid.getBoundingClientRect();
            const firstRect = firstCircle.getBoundingClientRect();
            const lastRect = lastCircle.getBoundingClientRect();

            // Calculate geometry relative to grid
            const startY = (firstRect.top - gridRect.top) + (firstRect.height / 2);
            const endY = (lastRect.top - gridRect.top) + (lastRect.height / 2);
            const totalHeight = Math.max(0, endY - startY);
            const centerX = (firstRect.left - gridRect.left) + (firstRect.width / 2);

            track.style.top = startY + "px";
            track.style.height = totalHeight + "px";
            track.style.left = centerX + "px";

            if (totalHeight <= 0) return;

            // Trigger point at 58% of mobile viewport height
            const triggerY = window.innerHeight * 0.58;

            const firstCircleCenterViewport = firstRect.top + (firstRect.height / 2);
            const lastCircleCenterViewport = lastRect.top + (lastRect.height / 2);

            let progress = 0;
            if (triggerY >= firstCircleCenterViewport) {
                if (triggerY >= lastCircleCenterViewport) {
                    progress = 1;
                } else {
                    progress = (triggerY - firstCircleCenterViewport) / (lastCircleCenterViewport - firstCircleCenterViewport);
                }
            }
            progress = Math.max(0, Math.min(1, progress));

            // Update fill bar height
            bar.style.height = (progress * 100) + "%";
            if (progress > 0.01) {
                bar.classList.add("has-progress");
            } else {
                bar.classList.remove("has-progress");
            }

            const currentBarBottomViewport = firstCircleCenterViewport + (progress * (lastCircleCenterViewport - firstCircleCenterViewport));

            // Activate steps as bar reaches each circle
            circles.forEach((circle, idx) => {
                const item = items[idx];
                const circleCenterViewport = circle.getBoundingClientRect().top + (circle.offsetHeight / 2);

                const isReached = (idx === 0 && triggerY >= firstCircleCenterViewport) || (currentBarBottomViewport >= circleCenterViewport - 4);

                if (isReached) {
                    item.classList.add("is-active");
                    circle.classList.add("is-active");
                } else {
                    item.classList.remove("is-active");
                    circle.classList.remove("is-active");
                }
            });
        }

        section._updateTimeline = updateTimeline;

        let isTicking = false;
        function onScroll() {
            if (!isTicking) {
                window.requestAnimationFrame(() => {
                    updateTimeline();
                    isTicking = false;
                });
                isTicking = true;
            }
        }

        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll, { passive: true });
        window.addEventListener("orientationchange", onScroll, { passive: true });

        // Update when images load to ensure precise height
        const images = section.querySelectorAll(".how-it-works__image");
        images.forEach((img) => {
            if (!img.complete) {
                img.addEventListener("load", onScroll);
            }
        });

        // Initial calculations
        setTimeout(updateTimeline, 100);
        setTimeout(updateTimeline, 300);
        setTimeout(updateTimeline, 700);
        updateTimeline();
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStepsMobileTimeline);
} else {
    initStepsMobileTimeline();
}
window.addEventListener("load", initStepsMobileTimeline);

document.addEventListener("shopify:section:load", (event) => {
    if (event.target && event.target.querySelector(".how-it-works--timeline")) {
        initStepsMobileTimeline();
    }
});

function checkAndScrollToHowItWorks() {
    if (window.location.hash === "#how-isochia-works" || window.location.hash === "#how-it-works") {
        const el = document.getElementById("how-isochia-works") || document.getElementById("how-it-works");
        if (el) {
            setTimeout(() => {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 100);
        }
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkAndScrollToHowItWorks);
} else {
    checkAndScrollToHowItWorks();
}
window.addEventListener("load", checkAndScrollToHowItWorks);
window.addEventListener("hashchange", checkAndScrollToHowItWorks);


  } catch(e) { console.error(e); }
})();
})();
